import React from 'react';
import { ListItem } from './list-item';
import { ListResultsProps } from 'app/area/external-urls-administration/list/types-store';
import { ListHeading } from 'app/area/external-urls-administration/list/components/list-heading';
import styles from './list-results.scss';

export const ListResults: React.FC<ListResultsProps> = ({
  listItems, deletingExternalUrls, deleteExternalUrl, translation
}) => {
  const disabledItemExists = listItems.some(item => item?.disabled);

  return listItems?.length > 0
    ? <div className={styles.listItems}>
      <ListHeading disabledItemExists={disabledItemExists} translation={translation} />
      {listItems.map(listItem => {
        return <ListItem
          key={listItem.id}
          item={listItem}
          deleting={deletingExternalUrls?.includes(listItem.id)}
          deleteExternalUrl={deleteExternalUrl}
          disabledItemExists={disabledItemExists}
          translation={translation} />;
      })}
    </div>
    : null;
};
